import { translate } from '@gig/magic-common';
import '@gig/magic-sdk/dist/adapter/users/getAmlStatus';

var SectionFileType;
(function (SectionFileType) {
    SectionFileType["NATIONAL_IDENTITY_CARD"] = "national_identity_card";
    SectionFileType["SOCIAL_SECURITY_CARD"] = "social_security_card";
    SectionFileType["DRIVING_LICENSE"] = "driving_license";
    SectionFileType["PASSPORT"] = "passport";
    SectionFileType["PAYSLIP"] = "payslip";
    SectionFileType["BANK_STATEMENT"] = "bank_statement";
    SectionFileType["TAX_RETURNS"] = "tax_returns";
    SectionFileType["EMPLOYMENT_LETTER"] = "employment_letter";
    SectionFileType["GRANT_OF_PROBATE"] = "grant_of_probate";
    SectionFileType["INSURANCE_PROCEEDS_CONTRACT"] = "insurance_proceeds_contract";
    SectionFileType["INVESTMENT_STATEMENT"] = "investment_statement";
    SectionFileType["LOAN_CONTRACT"] = "loan_contract";
    SectionFileType["CONTRACT_OF_SALE"] = "contract_of_sale";
    SectionFileType["LEASE_AGREEMENT"] = "lease_agreement";
    SectionFileType["RESIDENCE_PERMIT"] = "residence_permit";
    SectionFileType["UTILITY_BILL"] = "utility_bill";
    SectionFileType["SOURCE_OF_FUNDS"] = "source_of_funds";
    // for PAGCOR jurisdiction
    SectionFileType["VOTER_ID"] = "voter_id";
    SectionFileType["POSTAL_ID"] = "postal_id";
    SectionFileType["UNIFIED_MULTI_PURPOSE_ID"] = "unified_multi_purpose_id";
    SectionFileType["SOCIAL_SECURITY_SYSTEM_ID"] = "social_security_system_id";
    SectionFileType["PROFESSIONAL_REGULATION_COMISSION_ID"] = "professional_regulation_commission_id";
    SectionFileType["PHILIPPINE_MARITIME_INDUSTRY_AUTHORITY_CARD"] = "philippine_maritime_industry_authority_card";
    // not showing up in the form options
    SectionFileType["MILITARY_ID"] = "military_id";
    SectionFileType["ALIEN_REGISTRATION_CARD"] = "alien_registration_card";
    SectionFileType["RESIDENT_CARD"] = "resident_card";
})(SectionFileType || (SectionFileType = {}));
var documentNumberTypes = [
    SectionFileType.NATIONAL_IDENTITY_CARD,
    SectionFileType.PASSPORT,
    SectionFileType.DRIVING_LICENSE,
    SectionFileType.MILITARY_ID,
    SectionFileType.SOCIAL_SECURITY_CARD,
    SectionFileType.RESIDENT_CARD,
    SectionFileType.ALIEN_REGISTRATION_CARD,
    SectionFileType.RESIDENCE_PERMIT,
    SectionFileType.PHILIPPINE_MARITIME_INDUSTRY_AUTHORITY_CARD,
    SectionFileType.UNIFIED_MULTI_PURPOSE_ID,
    SectionFileType.SOCIAL_SECURITY_SYSTEM_ID,
    SectionFileType.VOTER_ID,
    SectionFileType.POSTAL_ID,
    SectionFileType.PROFESSIONAL_REGULATION_COMISSION_ID,
];
var documentExpirationTypes = [
    SectionFileType.NATIONAL_IDENTITY_CARD,
    SectionFileType.PASSPORT,
    SectionFileType.DRIVING_LICENSE,
    SectionFileType.MILITARY_ID,
    SectionFileType.SOCIAL_SECURITY_CARD,
    SectionFileType.RESIDENT_CARD,
    SectionFileType.ALIEN_REGISTRATION_CARD,
    SectionFileType.RESIDENCE_PERMIT,
    SectionFileType.PHILIPPINE_MARITIME_INDUSTRY_AUTHORITY_CARD,
    SectionFileType.UNIFIED_MULTI_PURPOSE_ID,
    SectionFileType.SOCIAL_SECURITY_SYSTEM_ID,
    SectionFileType.VOTER_ID,
    SectionFileType.POSTAL_ID,
    SectionFileType.PROFESSIONAL_REGULATION_COMISSION_ID,
];
var bothSideTypes = [
    SectionFileType.NATIONAL_IDENTITY_CARD,
    SectionFileType.DRIVING_LICENSE,
    SectionFileType.MILITARY_ID,
    SectionFileType.SOCIAL_SECURITY_CARD,
    SectionFileType.RESIDENT_CARD,
    SectionFileType.ALIEN_REGISTRATION_CARD,
    SectionFileType.PHILIPPINE_MARITIME_INDUSTRY_AUTHORITY_CARD,
    SectionFileType.UNIFIED_MULTI_PURPOSE_ID,
    SectionFileType.SOCIAL_SECURITY_SYSTEM_ID,
    SectionFileType.VOTER_ID,
    SectionFileType.POSTAL_ID,
    SectionFileType.PROFESSIONAL_REGULATION_COMISSION_ID,
];
function getIdDocumentTypeOptions() {
    return [
        {
            name: translate('verification-upload.document.type.national'),
            value: SectionFileType.NATIONAL_IDENTITY_CARD,
        },
        {
            name: translate('verification-upload.document.type.driving'),
            value: SectionFileType.DRIVING_LICENSE,
        },
        {
            name: translate('verification-upload.document.type.passport'),
            value: SectionFileType.PASSPORT,
        },
        {
            name: translate('verification-upload.document.type.social'),
            value: SectionFileType.SOCIAL_SECURITY_CARD,
        },
        {
            name: translate('verification-upload.document.type.industry'),
            value: SectionFileType.PHILIPPINE_MARITIME_INDUSTRY_AUTHORITY_CARD,
        },
        {
            name: translate('verification-upload.document.type.multi-purpose'),
            value: SectionFileType.UNIFIED_MULTI_PURPOSE_ID,
        },
        {
            name: translate('verification-upload.document.type.postal'),
            value: SectionFileType.POSTAL_ID,
        },
        {
            name: translate('verification-upload.document.type.voter'),
            value: SectionFileType.VOTER_ID,
        },
        {
            name: translate('verification-upload.document.type.comission'),
            value: SectionFileType.PROFESSIONAL_REGULATION_COMISSION_ID,
        },
        {
            name: translate('verification-upload.document.type.system'),
            value: SectionFileType.SOCIAL_SECURITY_SYSTEM_ID,
        },
    ];
}
function getAddressDocumentTypeOptions() {
    return [
        {
            name: translate('verification-upload.document.type.bank'),
            value: SectionFileType.BANK_STATEMENT,
        },
        {
            name: translate('verification-upload.document.type.utility'),
            value: SectionFileType.UTILITY_BILL,
        },
        {
            name: translate('verification-upload.document.type.lease'),
            value: SectionFileType.LEASE_AGREEMENT,
        },
        {
            name: translate('verification-upload.document.type.permit'),
            value: SectionFileType.RESIDENCE_PERMIT,
        },
    ];
}
function getPaymentDocumentTypeOptions() {
    return [
        {
            name: translate('verification-upload.document.type.payslip'),
            value: SectionFileType.PAYSLIP,
        },
        {
            name: translate('verification-upload.document.type.tax'),
            value: SectionFileType.TAX_RETURNS,
        },
        {
            name: translate('verification-upload.document.type.bank'),
            value: SectionFileType.BANK_STATEMENT,
        },
        {
            name: translate('verification-upload.document.type.employment'),
            value: SectionFileType.EMPLOYMENT_LETTER,
        },
        {
            name: translate('verification-upload.document.type.sale'),
            value: SectionFileType.CONTRACT_OF_SALE,
        },
        {
            name: translate('verification-upload.document.type.probate'),
            value: SectionFileType.GRANT_OF_PROBATE,
        },
        {
            name: translate('verification-upload.document.type.insurance'),
            value: SectionFileType.INSURANCE_PROCEEDS_CONTRACT,
        },
        {
            name: translate('verification-upload.document.type.investment'),
            value: SectionFileType.INVESTMENT_STATEMENT,
        },
        {
            name: translate('verification-upload.document.type.loan'),
            value: SectionFileType.LOAN_CONTRACT,
        },
    ];
}
function getSourceOfFundsDocumentTypeOptions() {
    return [
        {
            name: translate('verification-upload.document.type.payslip'),
            value: SectionFileType.PAYSLIP,
        },
        {
            name: translate('verification-upload.document.type.tax'),
            value: SectionFileType.TAX_RETURNS,
        },
        {
            name: translate('verification-upload.document.type.employment'),
            value: SectionFileType.EMPLOYMENT_LETTER,
        },
        {
            name: translate('verification-upload.document.type.bank'),
            value: SectionFileType.BANK_STATEMENT,
        },
        {
            name: translate('verification-upload.document.type.sale'),
            value: SectionFileType.CONTRACT_OF_SALE,
        },
        {
            name: translate('verification-upload.document.type.probate'),
            value: SectionFileType.GRANT_OF_PROBATE,
        },
        {
            name: translate('verification-upload.document.type.insurance'),
            value: SectionFileType.INSURANCE_PROCEEDS_CONTRACT,
        },
        {
            name: translate('verification-upload.document.type.investment'),
            value: SectionFileType.INVESTMENT_STATEMENT,
        },
        {
            name: translate('verification-upload.document.type.loan'),
            value: SectionFileType.LOAN_CONTRACT,
        },
    ];
}
var sectionFileTypeMap = {
    proof_of_identity: [
        SectionFileType.NATIONAL_IDENTITY_CARD,
        SectionFileType.DRIVING_LICENSE,
        SectionFileType.PASSPORT,
        SectionFileType.SOCIAL_SECURITY_CARD,
        SectionFileType.PHILIPPINE_MARITIME_INDUSTRY_AUTHORITY_CARD,
        SectionFileType.UNIFIED_MULTI_PURPOSE_ID,
        SectionFileType.POSTAL_ID,
        SectionFileType.VOTER_ID,
        SectionFileType.PROFESSIONAL_REGULATION_COMISSION_ID,
        SectionFileType.SOCIAL_SECURITY_SYSTEM_ID,
    ],
    payment: [
        SectionFileType.PAYSLIP,
        SectionFileType.TAX_RETURNS,
        SectionFileType.BANK_STATEMENT,
        SectionFileType.EMPLOYMENT_LETTER,
        SectionFileType.CONTRACT_OF_SALE,
        SectionFileType.GRANT_OF_PROBATE,
        SectionFileType.INSURANCE_PROCEEDS_CONTRACT,
        SectionFileType.INVESTMENT_STATEMENT,
        SectionFileType.LOAN_CONTRACT,
    ],
    sof: [
        SectionFileType.PAYSLIP,
        SectionFileType.TAX_RETURNS,
        SectionFileType.EMPLOYMENT_LETTER,
        SectionFileType.BANK_STATEMENT,
        SectionFileType.CONTRACT_OF_SALE,
        SectionFileType.GRANT_OF_PROBATE,
        SectionFileType.INSURANCE_PROCEEDS_CONTRACT,
        SectionFileType.INVESTMENT_STATEMENT,
        SectionFileType.LOAN_CONTRACT,
    ],
};
function getTranslationKeyForDocType(docType) {
    switch (docType) {
        // PHOTO_ID
        case SectionFileType.NATIONAL_IDENTITY_CARD:
            return 'verification-upload.document.type.national';
        case SectionFileType.DRIVING_LICENSE:
            return 'verification-upload.document.type.driving';
        case SectionFileType.PASSPORT:
            return 'verification-upload.document.type.passport';
        case SectionFileType.SOCIAL_SECURITY_CARD:
            return 'verification-upload.document.type.social';
        case SectionFileType.PHILIPPINE_MARITIME_INDUSTRY_AUTHORITY_CARD:
            return 'verification-upload.document.type.industry';
        case SectionFileType.UNIFIED_MULTI_PURPOSE_ID:
            return 'verification-upload.document.type.multi-purpose';
        case SectionFileType.POSTAL_ID:
            return 'verification-upload.document.type.postal';
        case SectionFileType.VOTER_ID:
            return 'verification-upload.document.type.voter';
        case SectionFileType.PROFESSIONAL_REGULATION_COMISSION_ID:
            return 'verification-upload.document.type.comission';
        case SectionFileType.SOCIAL_SECURITY_SYSTEM_ID:
            return 'verification-upload.document.type.system';
        // ADDRESS
        case SectionFileType.BANK_STATEMENT:
            return 'verification-upload.document.type.bank';
        case SectionFileType.UTILITY_BILL:
            return 'verification-upload.document.type.utility';
        case SectionFileType.LEASE_AGREEMENT:
            return 'verification-upload.document.type.lease';
        case SectionFileType.RESIDENCE_PERMIT:
            return 'verification-upload.document.type.permit';
        // PAYMENT / SOURCE_OF_FUNDS (shared types)
        case SectionFileType.PAYSLIP:
            return 'verification-upload.document.type.payslip';
        case SectionFileType.TAX_RETURNS:
            return 'verification-upload.document.type.tax';
        case SectionFileType.EMPLOYMENT_LETTER:
            return 'verification-upload.document.type.employment';
        case SectionFileType.CONTRACT_OF_SALE:
            return 'verification-upload.document.type.sale';
        case SectionFileType.GRANT_OF_PROBATE:
            return 'verification-upload.document.type.probate';
        case SectionFileType.INSURANCE_PROCEEDS_CONTRACT:
            return 'verification-upload.document.type.insurance';
        case SectionFileType.INVESTMENT_STATEMENT:
            return 'verification-upload.document.type.investment';
        case SectionFileType.LOAN_CONTRACT:
            return 'verification-upload.document.type.loan';
        default:
            return "verification-upload.document.type." + docType.toLowerCase();
    }
}
function getDocumentSideOptions() {
    return [
        {
            name: translate('verification-upload.side.front'),
            value: 'FRONT',
        },
        {
            name: translate('verification-upload.side.back'),
            value: 'BACK',
        },
    ];
}

export { SectionFileType, bothSideTypes, documentExpirationTypes, documentNumberTypes, getAddressDocumentTypeOptions, getDocumentSideOptions, getIdDocumentTypeOptions, getPaymentDocumentTypeOptions, getSourceOfFundsDocumentTypeOptions, getTranslationKeyForDocType, sectionFileTypeMap };
